<template>
	<div class="item">
		<div class="item__heading">
			<span v-if="article.parentArticleId" class="item__leader--v"></span>
			<span v-if="article.parentArticleId" class="item__leader--h"></span>
			<span
				v-if="article.parentArticleId && !isLast"
				class="item__leader--v-down"
				:style="{ height: downLeaderHeight }"
			></span>

			<router-link
				class="item__link"
				:class="{ 'item-unpublished': !article.published }"
				:to="{ path: 'article-view', query: { id: article.id } }"
			>
				<span class="title">{{ article.title }}</span>
				<span
					class="item__link--subtle"
					v-if="article.aliases && article.aliases.length > 0"
				>
					/{{ article.aliases.join(", ") }}/
				</span>
			</router-link>

			<div class="item__controls">
				<button
					class="btn btn-outline-secondary"
					v-if="isAdmin"
					@click="addArticle(article.id)"
				>
					<i class="fa-solid fa-plus"></i>
				</button>
				<button
					class="btn btn-outline-secondary ml-3"
					v-if="isAdmin"
					@click="openConfirmDialog(article.id)"
				>
					<i class="fa-solid fa-trash-can"></i>
				</button>
			</div>
		</div>
		<div class="item__children">
			<ChildTree
				v-for="(a, i) in article.children"
				:key="i"
				:article="a"
				:isLast="isLastChild(i)"
				:isAdmin="isAdmin"
				@deletearticle="deleteChild"
			/>
		</div>
		<ConfirmDialog
			:message="'Delete article?'"
			ref="confModal"
			@confirmdelete="deleteArticle"
			@refusedelete="$refs.confModal.hide()"
		/>
		<ErrorDialog ref="errDialog" />
	</div>
</template>

<script>
import ErrorDialog from "../../shared/ErrorDialog";
import ConfirmDialog from "../../shared/ConfirmDialog";
import Article from "../../../services/article";
import UtilityFunctions from "../../../util/classes/UtilityFunctions";

export default {
	name: "ChildTree",
	components: {
		ErrorDialog,
		ConfirmDialog,
	},
	props: ["article", "isLast", "isAdmin"],
	methods: {
		isLastChild: function (index) {
			if (!this.article) return;
			return !this.article.children[index + 1];
		},
		deleteArticle: function () {
			let id = this.selectedId;
			Article.instance()
				.deleteArticle(id)
				.then(() => {
					this.selectedId = "";
					this.$refs.confModal.hide();
					if (
						this.article.children &&
						this.article.children.length > 0
					) {
						Article.instance().events.emit(
							"addtoothers",
							this.article.children
						);
					}
					this.$emit("deletearticle", this.article);
					this.$store.dispatch("fetchIndexArticles");
				})
				.catch((error) => {
					this.$refs.errDialog.show(error);
					this.selectedId = "";
					this.$refs.confModal.hide();
				});
		},
		deleteChild: function (article) {
			this.article.children = this.article.children.filter(
				(a) => a.id != article.id
			);
		},
		addArticle: function (id) {
			Article.instance()
				.editArticle({
					title: "New article",
					parentArticleId: id,
					html: "<h2>Synopsis</h2><p></p>",
				})
				.then((res) => {
					this.article.children.push(res.data);
					this.$store.dispatch("fetchIndexArticles");
				})
				.catch((error) => {
					this.$refs.errDialog.show(error);
				});
		},
		openConfirmDialog: function (id) {
			this.selectedId = id;
			this.$refs.confModal.show();
		},
	},
	computed: {
		downLeaderHeight: function () {
			return 30 + 46 * UtilityFunctions.calcTreeLength(this.article.children) + 'px';
		},
	},
};
</script>

<style scoped>

.btn {
	padding: 0.2em 0.6em;
	border: none;
}
.btn:not(:hover) {
	background: transparent;
}

.item {
	color: var(--clr-accent-primary);
}

.item__leader--v {
	display: inline-block;
	position: absolute;
	left: -2.8rem;
	top: 50%;
	width: 1px;
	height: 2.8rem;
	transform: translate(50%, -100%);
	background-color: var(--guidePrimary);
}
.item__leader--h {
	display: inline-block;
	position: absolute;
	left: 0;
	top: 50%;
	transform: translate(-100%, -50%);
	width: 2.7rem;
	height: 1px;
	background-color: var(--guidePrimary);
}
.item__leader--v-down {
	display: inline-block;
	position: absolute;
	left: -2.8rem;
	top: 50%;
	width: 1px;
	height: 0;
	transform: translate(50%, 0);
	background-color: var(--guidePrimary);
}
.doc-index__item > .item > .item__heading::before {
	display: inline-block;
	content: '';
	width: 0.6em;
	height: 0.6em;
	background: #EEE;
	border: 1px solid #ccc;
	border-radius: 0.3em;
	position: relative;
	left: -0.23em;
	z-index: 100;
}
.item__heading {
	position: relative;
	margin-bottom: 0.7rem;
	padding-right: 0.5em;
	display: flex;
	align-items: center;
	transition: background 0.3s ease-in;
	padding-block: 0.4em;
}
.item__heading:hover {
	background: #EEE;
}


.item__children .item__heading {
	padding-left: 0.5em;
	border-left: 1px solid #ccc;
}
.item__children {
	padding-left: 2.7rem;
}
.item__link {
	color: var(--clr-accent-primary);
}
.item__link span {
	display: inline;
}
.item__link--subtle {
	color: var(--textTertiary);
}
.item-unpublished {
	color: var(--textTertiary);
}
.item__controls {
	display: flex;
	align-items: center;
	margin-left: auto;
}
</style>